import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withKeys as _withKeys } from "vue";
const _hoisted_1 = { class: "grey lighten-5 px-4 py-4" };
const _hoisted_2 = { class: "require-field-wrapper pb-4" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_DialogHeader = _resolveComponent("DialogHeader");
    const _component_v_card_text = _resolveComponent("v-card-text");
    const _component_v_radio = _resolveComponent("v-radio");
    const _component_v_radio_group = _resolveComponent("v-radio-group");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_DialogFooter = _resolveComponent("DialogFooter");
    const _component_v_card = _resolveComponent("v-card");
    const _component_v_dialog = _resolveComponent("v-dialog");
    return (_openBlock(), _createBlock(_component_v_dialog, {
        modelValue: _ctx.dialog,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.dialog) = $event)),
        scrollable: "",
        "content-class": "responsive-dialog",
        "onClick:outside": _ctx.handleClickCancel,
        onKeydown: _withKeys(_ctx.handleClickCancel, ["esc"])
    }, {
        activator: _withCtx(({ props }) => [
            _renderSlot(_ctx.$slots, "activator", _normalizeProps(_guardReactiveProps(props)), () => [
                _createVNode(_component_v_btn, _mergeProps(props, {
                    class: "cy-btn-cancel-allocate btn-outlined-basic",
                    color: "red darken-1",
                    large: "",
                    variant: "outlined",
                    width: "200",
                    height: "52",
                    disabled: _ctx.disabled,
                    onClick: _ctx.handleModalOpen
                }), {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}cancel_accepted`)), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["disabled", "onClick"])
            ], true)
        ]),
        default: _withCtx(() => [
            _createVNode(_component_v_card, {
                flat: "",
                tile: ""
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_DialogHeader, {
                        title: _ctx.$t(`${_ctx.lc}cancel_accepted`),
                        "on-cancel": _ctx.handleClickCancel
                    }, null, 8 /* PROPS */, ["title", "on-cancel"]),
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_v_card_text, { class: "text-body-1 pb-0 text-black" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}cancel_accepted_description`)), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_card_text, { class: "text-subtitle-2 brg-color-grey-600 pb-2" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}cancel_accepted_reason_label`)), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_radio_group, {
                                modelValue: _ctx.radioGroup,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.radioGroup) = $event)),
                                name: "radioGroup",
                                mandatory: "",
                                inline: "",
                                density: "compact",
                                "hide-details": "auto",
                                class: "px-4 pt-0 mt-0"
                            }, {
                                default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cancelAcceptedOptions, (option, key) => {
                                        return (_openBlock(), _createBlock(_component_v_radio, {
                                            key: key,
                                            label: option.label,
                                            value: option.value
                                        }, null, 8 /* PROPS */, ["label", "value"]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue"])
                        ])
                    ]),
                    _createVNode(_component_v_divider),
                    _createVNode(_component_DialogFooter, {
                        cancel: "",
                        ok: "",
                        "on-cancel": _ctx.handleClickCancel,
                        "on-ok": _ctx.handleClickOk
                    }, null, 8 /* PROPS */, ["on-cancel", "on-ok"])
                ]),
                _: 1 /* STABLE */
            })
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["modelValue", "onClick:outside", "onKeydown"]));
}
